import { NFTBaseContract } from "./../../types/index";
import { BaseContract, Token } from "types";
import { ensure } from "helpers/utils";
const ERC20ABI = require("../abi/token.json");
const WETHABI = require("../abi/weth.json");
const RAMABI = require("../abi/ram-token.json");
const NFTFACTORYABI = require("../abi/nftfactory.json");
const LINKABI = require("../abi/link-token.json");
const STORAGEABI = require("../abi/storage.json");
const MULTIPLIERABI = require("../abi/multiplier.json");
const RAMVAULTABI = require("../abi/ramvault.json");
const GOVERNANCEABI = require("../abi/governance.json");
const ROUTERABI = require("../abi/router.json");
const NFTABI = require("../abi/nft.json");

export const getContractByName = (name: string, network: string) =>
  ensure(contracts[network].find((contract) => contract.name.toLowerCase() === name.toLowerCase()));
export const getTokenByName = (name: string, network: string) =>
  ensure(tokens[network].find((contract) => contract.name.toLowerCase() === name.toLowerCase()));
export const getTokenByAddress = (address: string, network: string) =>
  ensure(tokens[network].find((contract) => contract.address.toLowerCase() === address.toLowerCase()));

export const contracts: { [network: string]: BaseContract[] } = {
  unknown: [
    { name: "Vault", address: "0x0DCd1Bf9A1b36cE34237eEaFef220932846BCD82", abi: RAMVAULTABI },
    { name: "Router", address: "0x1613beB3B2C4f22Ee086B2b38C1476A3cE7f78E8", abi: ROUTERABI },
    { name: "Governance", address: "0x2bdCC0de6bE1f7D2ee689a0342D76F52E8EFABa3", abi: GOVERNANCEABI },
    { name: "Storage", address: "0x2279B7A0a67DB372996a5FaB50D91eAA73d2eBe6", abi: STORAGEABI },
    { name: "NFTFactory", address: "0x610178dA211FEF7D417bC0e6FeD39F05609AD788", abi: NFTFACTORYABI },
    { name: "Multiplier", address: "0xB0D4afd8879eD9F52b28595d31B441D079B2Ca07", abi: MULTIPLIERABI },
  ],
  kovan: [
    { name: "Vault", address: "0x5357fdB7c7F0292aeb9f55F7c459Db3B927503f7", abi: RAMVAULTABI },
    { name: "Router", address: "0x346a23bbBA3dc8f5bFdA54629571A74F5bD36aFB", abi: ROUTERABI },
    { name: "Storage", address: "0x8D9657217799105a2273edfc56Ea3d7806Fe9c44", abi: STORAGEABI },
    { name: "Governance", address: "0xf85f97e34C9a94ac69186e300cDE9412b6308d42", abi: GOVERNANCEABI },
    { name: "NFTFactory", address: "0x51e5E2A2c89e17B1D327Bd4Aa9065F654E8Ee44C", abi: NFTFACTORYABI },
    { name: "Multiplier", address: "0x1B4BB94f42C4a4FEb4E0e91cc1E5421A6490e3C9", abi: MULTIPLIERABI },
  ],
  homestead: [
    { name: "Vault", address: "0x91420d8cbEdaBf9778680708A7092bb4812e54d3", abi: RAMVAULTABI },
    { name: "Router", address: "0xaa9b2b4d75c5176c6c8974a8e9db053a1eded47d", abi: ROUTERABI },
    { name: "Storage", address: "0x92518d01b16EFd0a1f86BD037b098AbBD169326F", abi: STORAGEABI },
    { name: "Governance", address: "0x7E806e9166B3367c6f7E5bDE995258eF35Eb1527", abi: GOVERNANCEABI },
    { name: "NFTFactory", address: "0xc90c5aE146B37d822bf18cb8cECc5260331be67e", abi: NFTFACTORYABI },
    { name: "Multiplier", address: "0xA8BD39d0917aa89Ed16260E27Bf457d8da4322fc", abi: MULTIPLIERABI },
  ],
};

export const NFTs: { [network: string]: NFTBaseContract[] } = {
  unknown: [
    {
      name: "RAM1",
      address: "0x6F1216D1BFe15c98520CA1434FC1d9D57AC95321",
      abi: NFTABI,
    },
    {
      name: "RAM2",
      address: "0xdAD42D43ecE0f6e8da8c2BCbC6A25FF6b3922C58",
      abi: NFTABI,
    },
    {
      name: "RAM3",
      address: "0xCBd5431cC04031d089c90E7c83288183A6Fe545d",
      abi: NFTABI,
    },
    {
      name: "RAM4",
      address: "0x40a87c555319e8bD334b209CA3fA22615b9c619e",
      abi: NFTABI,
    },
    {
      name: "RAM5",
      address: "0x193198556d1DbF455Aa063050eC1Cb039E8acECf",
      abi: NFTABI,
    },
    {
      name: "ROBOT",
      address: "0xa0E2E37c8bA56cD19fe3BD70f8c9390C0e3Dd5d8",
      abi: NFTABI,
    },
    {
      name: "LINK",
      address: "0xbb55fe723929CcB45a12C03fc91EBeD5407C8a6A",
      abi: NFTABI,
    },
  ],
  kovan: [
    {
      name: "RAM1",
      address: "0xCa5d2bF39ad9e57D36ED150220c642114Cca1924",
      abi: NFTABI,
    },
    {
      name: "RAM2",
      address: "0x49455AB50A5334E7F87E724f84C8372C0c2Cf6Aa",
      abi: NFTABI,
    },
    {
      name: "RAM3",
      address: "0x583Ef71927df373De882dbD6Fdc50a2eA7226f51",
      abi: NFTABI,
    },
    {
      name: "RAM4",
      address: "0x2b642F7fA7C919A23285EE44d8820a6AdE060195",
      abi: NFTABI,
    },
    {
      name: "RAM5",
      address: "0x79055c44b513cf7965aC7683173aAe713Afaf207",
      abi: NFTABI,
    },
    {
      name: "ROBOT",
      address: "0xB5eF246C7d2569c712033c633A51242daff2A6f8",
      abi: NFTABI,
    },
    {
      name: "LINK",
      address: "0x7Ccfe988c9DBD8B7891a89a3497a0dD8f9e03586",
      abi: NFTABI,
    },
  ],
  homestead: [
    {
      name: "RAM1",
      address: "0x0a77EF606882Eb7F2822F0876f2C5027B3A2A10B",
      abi: NFTABI,
    },
    {
      name: "RAM2",
      address: "0x5c1Fb5Bf718596Ee68099E5e1652F89b864B98bf",
      abi: NFTABI,
    },
    {
      name: "RAM3",
      address: "0xEd0aDC9355275CC3C2fd68eD56Fb2c8ABa82b0C4",
      abi: NFTABI,
    },
    {
      name: "RAM4",
      address: "0x411560bCe548aCDc2a7d24891870741052b82415",
      abi: NFTABI,
    },
    {
      name: "RAM5",
      address: "0x10B77892493a8fc0F76037206D445786E4cA84fe",
      abi: NFTABI,
    },
    {
      name: "ROBOT",
      address: "0xbdB6b5D3DFB0742E69d49182fbaCf4f3D2c04Abd",
      abi: NFTABI,
    },
    {
      name: "LINK",
      address: "0x56B376Ad4444B546974a5F3A761BCd2F2F0998dc",
      abi: NFTABI,
    },
  ],
};

export const tokens: { [network: string]: Token[] } = {
  unknown: [
    {
      name: "WETH",
      address: "0x9fE46736679d2D9a65F0992F2272dE9f3c7fa6e0",
      abi: WETHABI,
      decimals: 18,
    },
    {
      name: "YGY",
      address: "0xCf7Ed3AccA5a467e9e704C703E8D87F634fB0Fc9",
      abi: ERC20ABI,
      decimals: 6,
      getFrom: "https://info.uniswap.org/pair/0xa568b6f1173d6c6affd12655ac0eb22f766bbdb0",
    },
    {
      name: "RAM",
      address: "0xDc64a140Aa3E981100a9becA4E685f962f0cF6C9",
      abi: RAMABI,
      decimals: 18,
      getFrom: "https://info.uniswap.org/pair/0xdeaca5ae8a9426e4c9e2ea14d7223ca251ce7e5a",
    },
    {
      name: "YGY/RAM",
      address: "0xa4c0817cCb516C15Bc0a7c2F8038520042c34795",
      abi: ERC20ABI,
      decimals: 18,
      isLPToken: true,
    },
    {
      name: "LINK",
      address: "0xe7f1725E7734CE288F8367e1Bb143E90bb3F0512",
      abi: LINKABI,
      decimals: 18,
    },
    {
      name: "DXIOT",
      address: "0x5FC8d32690cc91D4c39d9d3abcBD16989F875707",
      abi: ERC20ABI,
      decimals: 18,
    },
    {
      name: "DXIOT",
      address: "0x7B784e12E240346381217B6EA54CDB0352C683e2",
      abi: ERC20ABI,
      decimals: 18,
    },
    {
      name: "XIOT",
      address: "0xc351628EB244ec633d5f21fBD6621e1a683B1181",
      abi: ERC20ABI,
      decimals: 3,
      getFrom: "https://info.uniswap.org/pair/0x5741a1ceff6148c8aaca0f0456c03c88817e05f5",
    },
    {
      name: "Axioms",
      address: "0xFD471836031dc5108809D173A067e8486B9047A3",
      abi: ERC20ABI,
      decimals: 18,
      getFrom: "https://info.uniswap.org/pair/0x0f3ce875cd56870ec7915e0fa247a202685888c5",
    },
    {
      name: "UNI",
      address: "0xcbEAF3BDe82155F56486Fb5a1072cb8baAf547cc",
      abi: ERC20ABI,
      decimals: 18,
      getFrom: "https://info.uniswap.org/pair/0xd3d2e2692501a5c9ca623199d38826e513033a17",
    },
  ],
  kovan: [
    {
      name: "WETH",
      address: "0x25387E2fcC60c3B0AfE6716DEE4AB6BDbbE6D4c3",
      abi: WETHABI,
      decimals: 18,
    },
    {
      name: "YGY",
      address: "0x2B0c57084F5ab0eF27323668F70820df252f0725",
      abi: ERC20ABI,
      decimals: 6,
      getFrom: "https://info.uniswap.org/pair/0xa568b6f1173d6c6affd12655ac0eb22f766bbdb0",
    },
    {
      name: "RAM",
      address: "0x262E315F7F3277E64b8fdf194f4e23298339f94A",
      abi: RAMABI,
      decimals: 18,
      getFrom: "https://info.uniswap.org/pair/0xdeaca5ae8a9426e4c9e2ea14d7223ca251ce7e5a",
    },
    {
      name: "YGY/RAM",
      address: "0x27CC1D900B00638D2F81700E53ECBd996BAcEA1D",
      abi: ERC20ABI,
      decimals: 18,
      isLPToken: true,
    },
    {
      name: "LINK",
      address: "0xa36085F69e2889c224210F603D836748e7dC0088",
      abi: LINKABI,
      decimals: 18,
    },
    {
      name: "DXIOT",
      address: "0xf61EF41AfceB10e8162d11806A9F7cD21aF0D76A",
      abi: ERC20ABI,
      decimals: 18,
    },
    {
      name: "XIOT",
      address: "0x3fa31dF4dB9295783255f946BF9e1c6231e3E2C7",
      abi: ERC20ABI,
      decimals: 3,
      getFrom: "https://info.uniswap.org/pair/0x5741a1ceff6148c8aaca0f0456c03c88817e05f5",
    },
    {
      name: "Axioms",
      address: "0xf30C68532dE51661af77ffF01Fd6820B6bC722fC",
      abi: ERC20ABI,
      decimals: 18,
      getFrom: "https://info.uniswap.org/pair/0x0f3ce875cd56870ec7915e0fa247a202685888c5",
    },
    {
      name: "UNI",
      address: "0xfB55a2B319B7d3aA13A0944729A62216BBbeef95",
      abi: ERC20ABI,
      decimals: 18,
      getFrom: "https://info.uniswap.org/pair/0xd3d2e2692501a5c9ca623199d38826e513033a17",
    },
  ],
  homestead: [
    {
      name: "WETH",
      address: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
      abi: ERC20ABI,
      decimals: 18,
    },
    {
      name: "YGY",
      address: "0x11b0a8C0FA626627601eD518c3538a39d92D609E",
      abi: ERC20ABI,
      decimals: 6,
      getFrom: "https://info.uniswap.org/pair/0xa568b6f1173d6c6affd12655ac0eb22f766bbdb0",
    },
    {
      name: "RAM",
      address: "0xdDec5CB890b066891151E5f6ffCA101b4EB47409",
      abi: ERC20ABI,
      decimals: 18,
      getFrom: "https://info.uniswap.org/pair/0xdeaca5ae8a9426e4c9e2ea14d7223ca251ce7e5a",
    },
    {
      name: "DXIOT",
      address: "0x8b6DD24Bcb2D0aeA92c3AbD4eB11103A5DB6D714",
      abi: ERC20ABI,
      decimals: 18,
    },
    {
      name: "LINK",
      address: "0x514910771af9ca656af840dff83e8264ecf986ca",
      abi: ERC20ABI,
      decimals: 18,
    },
    {
      name: "YGY/RAM",
      address: "0xdEaca5ae8a9426E4c9E2eA14d7223cA251ce7e5a",
      abi: ERC20ABI,
      decimals: 18,
    },
    {
      name: "XIOT",
      address: "0x31024a4c3e9aeeb256b825790f5cb7ac645e7cd5",
      abi: ERC20ABI,
      decimals: 3,
      getFrom: "https://info.uniswap.org/pair/0x5741a1ceff6148c8aaca0f0456c03c88817e05f5",
    },
    {
      name: "Axioms",
      address: "0x73ee6d7e6b203125add89320e9f343d65ec7c39a",
      abi: ERC20ABI,
      decimals: 18,
      getFrom: "https://info.uniswap.org/pair/0x0f3ce875cd56870ec7915e0fa247a202685888c5",
    },
    {
      name: "UNI",
      address: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
      abi: ERC20ABI,
      decimals: 18,
      getFrom: "https://info.uniswap.org/pair/0xd3d2e2692501a5c9ca623199d38826e513033a17",
    },
  ],
};

export const localFarmingPools = [
  {
    id: "RAM",
    name: "RAM POOL",
    address: "0x162A433068F51e18b7d13932F27e66a3f99E6890",
    uniToken: getTokenByName("YGY/RAM", "unknown"),
    againstToken: getTokenByName("WETH", "unknown"),
    abi: require("../abi/pool.json"),
    stakingToken: getTokenByName("YGY/RAM", "unknown"),
    rewardToken: getTokenByName("RAM", "unknown"),
    startTime: new Date(1609876732000),
    multiplierTokens: [
      getTokenByName("YGY", "unknown"),
      getTokenByName("RAM", "unknown"),
      getTokenByName("Axioms", "unknown"),
      getTokenByName("UNI", "unknown"),
    ],
    info: "Stake YGY/RAM LP for RAM",
  },
  {
    id: "YGY",
    name: "YGY POOL",
    address: "0x922D6956C99E12DFeB3224DEA977D0939758A1Fe",
    uniToken: getTokenByName("YGY/RAM", "unknown"),
    againstToken: getTokenByName("WETH", "unknown"),
    abi: require("../abi/pool.json"),
    stakingToken: getTokenByName("YGY/RAM", "unknown"),
    rewardToken: getTokenByName("YGY", "unknown"),
    startTime: new Date(1609876732000),
    multiplierTokens: [
      getTokenByName("YGY", "unknown"),
      getTokenByName("RAM", "unknown"),
      getTokenByName("XIOT", "unknown"),
      getTokenByName("UNI", "unknown"),
    ],
    info: "Stake YGY/RAM LP for YGY",
  },
];

export const kovanFarmingPools = [
  {
    id: "RAM",
    name: "RAM POOL",
    address: "0x0879538487725e1c728D6D9da7C5227563B68fa5",
    uniToken: getTokenByName("YGY/RAM", "kovan"),
    againstToken: getTokenByName("WETH", "kovan"),
    abi: require("../abi/pool.json"),
    stakingToken: getTokenByName("YGY/RAM", "kovan"),
    rewardToken: getTokenByName("RAM", "kovan"),
    startTime: new Date(1609876732000),
    multiplierTokens: [
      getTokenByName("YGY", "kovan"),
      getTokenByName("RAM", "kovan"),
      getTokenByName("Axioms", "kovan"),
      getTokenByName("UNI", "kovan"),
    ],
    info: "Stake YGY/RAM LP for RAM",
  },
  {
    id: "YGY",
    name: "YGY POOL",
    address: "0xFbFdf9aa81744E03a35665Af4D9c85da9A7D68ea",
    uniToken: getTokenByName("YGY/RAM", "kovan"),
    againstToken: getTokenByName("WETH", "kovan"),
    abi: require("../abi/pool.json"),
    stakingToken: getTokenByName("YGY/RAM", "kovan"),
    rewardToken: getTokenByName("YGY", "kovan"),
    startTime: new Date(1609876732000),
    multiplierTokens: [
      getTokenByName("YGY", "kovan"),
      getTokenByName("RAM", "kovan"),
      getTokenByName("XIOT", "kovan"),
      getTokenByName("UNI", "kovan"),
    ],
    info: "Stake YGY/RAM LP for YGY",
  },
];

export const farmingPools = [
  {
    id: "RAM",
    name: "RAM POOL",
    address: "0x3bEC8502997AcCa052DA88aB180100a603429971",
    uniToken: getTokenByName("YGY/RAM", "homestead"),
    againstToken: getTokenByName("WETH", "homestead"),
    abi: require("../abi/pool.json"),
    stakingToken: getTokenByName("YGY/RAM", "homestead"),
    rewardToken: getTokenByName("RAM", "homestead"),
    startTime: new Date(1609970367000),
    multiplierTokens: [
      getTokenByName("YGY", "homestead"),
      getTokenByName("RAM", "homestead"),
      getTokenByName("Axioms", "homestead"),
      getTokenByName("UNI", "homestead"),
    ],
    info: "Stake YGY/RAM LP for RAM",
  },
  {
    id: "YGY",
    name: "YGY POOL",
    address: "0x15C6c35dB02acAAF51508f3F636ad2B2dc368391",
    uniToken: getTokenByName("YGY/RAM", "homestead"),
    againstToken: getTokenByName("WETH", "homestead"),
    abi: require("../abi/pool.json"),
    stakingToken: getTokenByName("YGY/RAM", "homestead"),
    rewardToken: getTokenByName("YGY", "homestead"),
    startTime: new Date(1609977567000),
    multiplierTokens: [
      getTokenByName("YGY", "homestead"),
      getTokenByName("RAM", "homestead"),
      getTokenByName("XIOT", "homestead"),
      getTokenByName("UNI", "homestead"),
    ],
    info: "Stake YGY/RAM LP for YGY",
  },
];
